module.exports = __webpack_public_path__ + "img/dc81a3a.jpg";